import styles from './userNavigation.module.css';
import UserListDropDown from '../userList/UserListDropDown';
import { useSelector } from 'react-redux';
import { selectSharedWorker } from 'store/transactionsSlice/transactionsSelectors';
import line from 'assets/line.svg';
import vector from 'assets/Vector.svg';
import AppListDropDown from '../appListDropDown/AppListDropDown';
import UploadStatusIndicator from '../../UI/Notifications/UploadStatusIndicator/UploadStatusIndicator';
import Help from '../help/Help';
import { Tooltip } from '@mui/material';
import { IconButton } from '@mui/material';
import { GENERAL } from 'config';
import { openInNewTab } from 'utils/domHelper';

export default function UserNavigation({ user }) {
    const { windowId, windowCount } = useSelector(selectSharedWorker) || {};
    const userType = user?.roles?.[0] || '';

    return (
        <>
            <div className={styles.userNavigation}>
                <UploadStatusIndicator />
                {windowId && (
                    <Tooltip title={`You have AIQ open in ${windowCount} tab(s). Viewing tab ${windowId} of ${windowCount}`}>
                        <IconButton sx={{ width: '40px', height: '40px' }}>
                            <div className={styles.desktopCount}>
                                <div className={styles.desktopImageVector}>
                                    <img alt="desktop" src={vector} />
                                </div>
                                <div className={styles.desktopImage}>
                                    <img alt="desktop" src={line} />
                                </div>
                                <p className={styles.desktopCountNumber}>
                                    {windowId}/{windowCount}
                                </p>
                            </div>
                        </IconButton>
                    </Tooltip>
                )}
                <Tooltip title="Keyboard shortcuts">
                    <IconButton sx={{ width: '40px', height: '40px' }}>
                        <Help />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Birdseye apps (open in new tab)">
                    <IconButton sx={{ width: '40px', height: '40px' }} onClick={() => openInNewTab(GENERAL.ADDRESSES.SSO)}>
                        <AppListDropDown />
                    </IconButton>
                </Tooltip>
                <UserListDropDown dropDownItems={[{ text: user?.username, roles: userType }]} user={user} />
            </div>
        </>
    );
}
